export default "__VITE_ASSET__DsCCmdwJ__"